const PRIORITY_TRANSLATIONS = {
  low: '低',
  medium: '中',
  high: '高',
  urgent: '紧急',
};

const translatePriority = priority =>
  PRIORITY_TRANSLATIONS[priority.toLowerCase()] || priority;

const LEGACY_ACTIVITY_TRANSLATIONS = [
  [
    /^Conversation was marked resolved by system due to (\d+) days? of inactivity$/,
    match => `会话因 ${match[1]} 天无操作被系统标记为已解决`,
  ],
  [
    /^Conversation was marked resolved by system due to (\d+) hours? of inactivity$/,
    match => `会话因 ${match[1]} 小时无操作被系统标记为已解决`,
  ],
  [
    /^Conversation was marked resolved by system due to (\d+) minutes? of inactivity$/,
    match => `会话因 ${match[1]} 分钟无操作被系统标记为已解决`,
  ],
  [
    /^Conversation was resolved by (.+)$/,
    match => `会话已由 ${match[1]} 解决`,
  ],
  [
    /^Conversation was marked resolved by (.+?) due to inactivity$/,
    match => `会话已由 ${match[1]} 因长时间无操作标记为已解决`,
  ],
  [
    /^Conversation was marked resolved by (.+?) \((.+)\)$/,
    match => `会话已由 ${match[1]} 标记为已解决（${match[2]}）`,
  ],
  [
    /^Conversation was marked resolved by (.+?): (.+)$/,
    match => `会话已由 ${match[1]} 标记为已解决：${match[2]}`,
  ],
  [
    /^Conversation was marked resolved by (.+)$/,
    match => `会话已由 ${match[1]} 标记为已解决`,
  ],
  [
    /^Conversation was marked open by (.+?) \((.+)\)$/,
    match => `会话已由 ${match[1]} 重新打开（${match[2]}）`,
  ],
  [
    /^Conversation was (?:reopened|marked open) by (.+)$/,
    match => `会话已由 ${match[1]} 重新打开`,
  ],
  [
    /^Conversation was marked as pending by (.+)$/,
    match => `会话已由 ${match[1]} 标记为待处理`,
  ],
  [
    /^Conversation was snoozed by (.+)$/,
    match => `会话已由 ${match[1]} 暂停`,
  ],
  [
    /^Conversation was marked open automatically after an agent reply$/,
    () => '客服回复后，系统已自动重新打开会话',
  ],
  [
    /^Conversation was marked open by system due to an error with the agent bot\.?$/,
    () => '由于客服机器人发生错误，系统已重新打开会话。',
  ],
  [
    /^System reopened the conversation due to a new incoming message\.?$/,
    () => '收到客户的新消息后，系统已重新打开会话。',
  ],
  [
    /^(.+?) set the priority to (.+)$/,
    match => `${match[1]} 将优先级设置为 ${translatePriority(match[2])}`,
  ],
  [
    /^(.+?) changed the priority from (.+) to (.+)$/,
    match =>
      `${match[1]} 将优先级从 ${translatePriority(
        match[2]
      )} 更改为 ${translatePriority(match[3])}`,
  ],
  [
    /^(.+?) removed the priority$/,
    match => `${match[1]} 取消了优先级`,
  ],
  [
    /^(.+?) self-assigned this conversation$/,
    match => `${match[1]} 自行接入此会话`,
  ],
  [
    /^Assigned to (.+?) via (.+?) by (.+)$/,
    match => `${match[3]} 通过 ${match[2]} 将会话分配给 ${match[1]}`,
  ],
  [
    /^Assigned to (.+?) by (.+)$/,
    match => `${match[2]} 将会话分配给 ${match[1]}`,
  ],
  [
    /^Conversation unassigned by (.+)$/,
    match => `${match[1]} 取消了客服分配`,
  ],
  [
    /^Unassigned from (.+?) by (.+)$/,
    match => `${match[2]} 将会话从 ${match[1]} 中移除`,
  ],
  [
    /^(.+?) added SLA policy (.+)$/,
    match => `${match[1]} 添加了 SLA 策略 ${match[2]}`,
  ],
  [
    /^(.+?) removed SLA policy (.+)$/,
    match => `${match[1]} 移除了 SLA 策略 ${match[2]}`,
  ],
  [
    /^(.+?) added (.+)$/,
    match => `${match[1]} 添加了标签 ${match[2]}`,
  ],
  [
    /^(.+?) removed (.+)$/,
    match => `${match[1]} 移除了标签 ${match[2]}`,
  ],
];

export const localizeLegacyActivityContent = (content, locale = 'zh_CN') => {
  if (!locale.toLowerCase().startsWith('zh') || typeof content !== 'string') {
    return content;
  }

  const normalizedContent = content
    .replaceAll('Automation System via ', '自动分配策略：')
    .replaceAll('Default Policy', '默认分配策略');

  for (const [pattern, translate] of LEGACY_ACTIVITY_TRANSLATIONS) {
    const match = normalizedContent.match(pattern);
    if (match) return translate(match);
  }

  return normalizedContent;
};
